import { InjectionToken, makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';

export interface UiLayoutConfig {
  /**
   * Namespaces the persisted sidenav-collapsed state. Give each app its own
   * value — otherwise apps served from the same origin share one setting.
   */
  storageKey: string;
  /** Below this width the sidenav becomes an overlay drawer. */
  handsetBreakpoint: string;
}

export const UI_LAYOUT_DEFAULTS: UiLayoutConfig = {
  storageKey: 'sisoma.sidenav-collapsed',
  handsetBreakpoint: '(max-width: 991.98px)',
};

export const UI_LAYOUT_CONFIG = new InjectionToken<UiLayoutConfig>('UI_LAYOUT_CONFIG', {
  providedIn: 'root',
  factory: () => UI_LAYOUT_DEFAULTS,
});

/**
 * Configures the app shell. Add to an app's `ApplicationConfig` providers:
 *
 * ```ts
 * provideUiLayout({ storageKey: 'partner-area.sidenav-collapsed' })
 * ```
 *
 * Returns `EnvironmentProviders` so the config can only be provided at the
 * environment level — providing it on a component would silently fork the
 * sidenav state for that subtree.
 */
export function provideUiLayout(config: Partial<UiLayoutConfig>): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: UI_LAYOUT_CONFIG,
      useValue: { ...UI_LAYOUT_DEFAULTS, ...config },
    },
  ]);
}
